import KBHomePage from '@pages/KBHomePage.jsx'
import SearchPage from '@pages/SearchPage.jsx'
import Loadable from '@components/common/loadable.jsx'
import { lazy } from 'react'
import { MainLayout } from '@templates/layout/MainLayout.jsx'

const NewsListPage = Loadable(lazy(() => import('@pages/NewsListPage.jsx')))
const NewsDetailPage = Loadable(lazy(() => import('@pages/NewsDetailPage.jsx')))
const StockDetailPage = Loadable(lazy(() => import('@pages/StockDetailPage.jsx')))
const StockExchangeDetailPage = Loadable(lazy(() => import('@pages/StockExchangeDetailPage.jsx')))

const aspRoutes = [
  {
    element: <MainLayout />,
    children: [
      {
        path: 'main',
        element: <KBHomePage />
      },
      {
        path: 'search',
        element: <SearchPage />
      },
      {
        path: 'stock',
        children: [
          {
            path: 'all/:assetId',
            element: <StockDetailPage />
          },
          { path: 'exchange/:assetId', element: <StockExchangeDetailPage /> }
        ]
      },
      {
        path: 'news',
        children: [
          { index: true, element: <NewsListPage /> },
          { path: ':key', element: <NewsDetailPage /> }
        ]
      }
    ]
  }
]

export default aspRoutes
